import { brightBlue, lightText } from "../../../constants/colors";
import { FONT_SIZE_SMALL } from "../../../constants/constants";

export const JOYRIDE_STYLES = {
  options: {
    arrowColor: brightBlue,
    backgroundColor: brightBlue,
    overlayColor: "none",
    primaryColor: "rgb(255, 0, 68)",
    textColor: lightText,
  },
  buttonClose: {
    fontSize: 24,
  },
  buttonNext: {
    backgroundColor: lightText,
    color: brightBlue,
    fontWeight: "bold" as any,
    padding: 12,
    marginRight: 15,
  },
  buttonBack: {
    color: lightText,
    fontWeight: "bold" as any,
    justifySelf: "end" as any,
    marginLeft: 0,
    fontSize: FONT_SIZE_SMALL,
  },
  buttonSkip: {
    // marginLeft: 150,
    fontSize: FONT_SIZE_SMALL,
  },
};
